<template>
  <div ref="test" class="notification_panel" id="notification-panel">
    <b-dropdown right no-caret variant="transparent" size="sm" @hidden="markAllRead" ref="panelDropdown">
      <template #button-content>
        <div @click="sendEvent" data-testid="notification-dropdown">
          <img class="notifcation-icon" :src="unviewed_notifications.length <= 0 ? BellIcon : BellIconActive" />
        </div>
      </template>
      <template #default>
        <div ref="notification-list" id="infinite-list">
          <div class="notification_heading bb">
            <div class="heading_title">
              Notifications
            </div>
          </div>
          <div v-if="unviewed_notifications.length > 0" class="type bb">
            Unread
          </div>
          <div class="notification bb" v-for="(notification, index) in unviewed_notifications" :key="'unviewed-notification-'+index" :data-testid="'unviewed-notification-'+index" @click="markNotificationViewed(notification)" >
            <div class="notification_main_content">
              <div class="notification_img_div" :style="{ backgroundImage: `url(${notification.attributes.image_url})` }">
              </div>
              <div class="notification_content">
                <span class="notification_title">
                  {{ notification.attributes.title }}
                </span>
                <span class="notification_subtitle">
                  {{ notification.attributes.body }}
                </span>
              </div>
            </div>
            <div class="time_ago">
              <time-ago :refresh="60" :datetime="new Date(notification.attributes.created_at)" locale="en" tooltip></time-ago>
            </div>
          </div>
          <div v-if="viewed_notifications.length > 0" class="type bb">
            Recent
          </div>
          <a class="notification bb" v-for="(notification, index) in viewed_notifications" :key="'viewed-notification-'+index" :data-testid="'viewed-notification-'+index" :href="notification.attributes.action_link" target="_blank">
            <div class="notification_main_content">
              <div class="notification_img_div" :style="{ backgroundImage: `url(${notification.attributes.image_url})` }">
              </div>
              <div class="notification_content">
                <span class="notification_title">
                  {{ notification.attributes.title }}
                </span>
                <span class="notification_subtitle">
                  {{ notification.attributes.body }}
                </span>
              </div>
            </div>
            <div class="time_ago">
              <time-ago :refresh="60" :datetime="new Date(notification.attributes.created_at)" locale="en" tooltip></time-ago>
            </div>
          </a>
        </div>
      </template>
    </b-dropdown>
  </div>
</template>

<script>
import BellIcon from '../../images/icons-notifications.svg';
import BellIconActive from '../../images/icons-notifications-active.svg'
import track from '@/src/tracking';
import api from '../api';
import TimeAgo from 'vue2-timeago'
import EventBus from '../event_bus';
import { mapState } from 'vuex';
import featureKey from "../feature_key.macro";

export default {
  components: {
    TimeAgo
  },
  data: function () {
    return {
      viewed_notifications: [],
      unviewed_notifications: [],
      BellIcon: BellIcon,
      BellIconActive: BellIconActive,
      loadViewedNotications: false,
      busy: false
    }
  },
  computed: {
    ...mapState({
      secondsToOpen: state => state.features?.[featureKey("web_notifications_auto_open")],
    }),
  },
  mounted: function () {
    const listElm = this.$refs["notification-list"];
    const vm = this;
    listElm.addEventListener('scroll', function() {
      if(Math.round(this.scrollTop + this.clientHeight) >= this.scrollHeight) {
        if (vm.loadViewedNotications) {
          vm.getViewedNotifications();
        } else {
          vm.getUnviewedNotifications();
        }
      }
    });
    this.updateNotification();
    EventBus.$on("notification:updated", this.updateNotification);

    if (this.$route.hash == '#open_notifications') {
      this.$refs.panelDropdown.show();
    }
  },
  methods: {
    openOnTimer: function() {
      setTimeout(() => {
          this.$refs.panelDropdown.show();
      }, this.secondsToOpen)
    },
    sendEvent: function () {
      track('notifications_list_opened', { campagin_source: "web" });
    },
    updateNotification: function () {
      this.unviewed_notifications = [];
      this.viewed_notifications = [];
      this.getUnviewedNotifications();
    },
    markAllRead: function () {
      let self = this;
      if (this.unviewed_notifications.length > 0) {
        let recent_notification = this.unviewed_notifications[0];
        let recent_created_at = recent_notification.attributes.created_at;
        api.patch(`/api/v5/client_notifications/update_unviewed_notifications`,
          {
            created_before: recent_created_at,
          })
          .then(function (response) {
            self.updateNotification();
          })
          .catch(function (err) {
            console.log(err);
          });
      }
    },
    getUnviewedNotifications: function () {
      let self = this;
      let params = {
        viewed: "no",
        limit: 10
      };
      if (this.unviewed_notifications.length > 0) {
        let last_notifcation = this.unviewed_notifications[this.unviewed_notifications.length - 1];
        params["created_before"] = last_notifcation["attributes"]["created_at"];
      }
      api.get("/api/v5/client_notifications", {
          params: params
        }).then(function (response) {
          if (response?.data?.data?.client_notifications) {
            if (response.data.data.client_notifications.length < 10) {
              self.loadViewedNotications = true;
              self.getViewedNotifications(10 - response.data.data.client_notifications.length)
            }
            self.unviewed_notifications = self.unviewed_notifications.concat(response.data.data.client_notifications);
            if (self.secondsToOpen) { self.openOnTimer() };
          } else {
            self.loadViewedNotications = true;
            self.getViewedNotifications();
          }
        }).catch(function (err) {
          console.log(err);
        });
    },
    getViewedNotifications: function (limit) {
      let self = this;
      let params = {
        viewed: "yes",
        limit: limit || 10
      };
      if (this.viewed_notifications.length > 0) {
        let last_notifcation = this.viewed_notifications[this.viewed_notifications.length - 1];
        params["created_before"] = last_notifcation["attributes"]["created_at"];
      }

      api.get("/api/v5/client_notifications", {
          params: params
        }).then(function (response) {
            if (response?.data?.data?.client_notifications) {
              self.viewed_notifications = self.viewed_notifications.concat(response.data.data.client_notifications);
            }
        }).catch(function (err) {
          console.log(err);
        });
    },
    markNotificationViewed: function (notification) {
      let self = this;
      api.patch(`/api/v5/client_notifications/${notification.id}`,
        {
          viewed: true,
          campagin_source: "web"
        }).then(function (response) {
            self.updateNotification();
            window.open(notification.attributes.action_link, '_blank');
          }).catch(function (err) {
            console.log(err);
          });
    }
  },
  watch: {
    secondsToOpen: function(seconds) {
      if (seconds && this.unviewed_notifications.length > 0) { this.openOnTimer() };
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../packs/application.scss';

.notification_panel {
  .notifcation-icon {
    cursor: pointer;
    margin-bottom: 3px;
  }

  .bb {
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  }

  .type {
    background: #fafafa;
    padding: 0.5rem 1.5rem;
    font-size: 0.75rem;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;

  }

  .notification_heading {
    display: flex;
    padding: 0.25rem 1.5rem;
    font-size: 0.75rem;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;

    .heading_title{
      flex: 1;
    }
  }

  /deep/ .dropdown-menu {
    padding-top: 1px;
  }

  #infinite-list {
    width: 25rem;
    height: 35rem;
    overflow-y: scroll;
    background: white;
  }

  .notification {
    display: flex;
    height: 6rem;
    padding: 0.75rem 1.25rem;
    color: $almost-black;
    font-size: 0.75rem;
    font-stretch: normal;
    text-decoration: none;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    cursor: pointer;
    justify-content: space-between;

    .notification_main_content {
      display: flex;
    }

    .notification_title {
      height: 2rem;
      margin-bottom: 0.5rem;
      text-overflow: ellipsis;
      overflow: hidden;
      display: flex;
    }

    .notification_subtitle {
      height: 2rem;
      text-overflow: ellipsis;
      overflow: hidden;
      display: flex;
    }

    .notification_img_div {
      height: 4.5rem;
      width: 6rem;
      background-size: cover;
      flex-shrink: 0;
    }

    .notification_img {
      height: 4.5rem;
    }

    .notification_content {
      padding: 0rem 0.5rem;
    }
    .time_ago {
      white-space: nowrap;
      font-size: 0.75rem;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.33;
      letter-spacing: normal;
      text-align: right;
    }
  }
  .notification:hover {
    text-decoration: none;
  }
}

</style>